// src/components/store/sections/testimonials/TestimonialV59BubblechatFuchsiaGlow.tsx
"use client";

import React from "react";
import DynamicTestimonialVariant from "./DynamicTestimonialVariant";

export default function TestimonialV59BubblechatFuchsiaGlow(props: any) {
  return (
    <DynamicTestimonialVariant
      variantNumber={59}
      archKey="bubble_chat"
      archLabel="Bubble Chat Cards"
      palName="FuchsiaGlow"
      grad="from-fuchsia-500 via-pink-500 to-purple-700"
      lightBg="bg-fuchsia-50"
      textCol="text-fuchsia-700"
      borderCol="border-fuchsia-200"
      btnCls="bg-fuchsia-600 hover:bg-fuchsia-700"
      hexCol="#d946ef"
      {...props}
    />
  );
}
